export type NullToUndefined<T> = {
  [P in keyof T]: T[P] extends null ? undefined : Exclude<T[P], null>;
};

/**
 * Take an object and replace all null properties with undefined.
 */
export const castNullToUndefined = <T extends object>(
  obj: T,
): NullToUndefined<T> => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      return [key, value === null ? undefined : value];
    }),
  ) as NullToUndefined<T>;
};
